import React, { FC } from 'react';
import PhotoUploadModal from './photo_upload_modal';
import { Button } from '../../../common/button';



interface IProps {
    propertyNhID: number;
    propertyName: string;
    propertySlug: string
}

const AddPhotosButton: FC<IProps> = ({ propertyNhID, propertyName, propertySlug }) => {
    const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <PhotoUploadModal
        handleClose={() => setShowModal(false)}
        isOpen={showModal}
        nhID={propertyNhID}
        propertySlug={propertySlug}
        propertyName={propertyName}
      />
      <Button
        type='button'
        onClick={() => setShowModal(!showModal)}
      >
        Add Photos
      </Button>
      
    </>
  );
};

export { AddPhotosButton };
